import './ScopeItemActionButton.scss';
import { Button } from 'antd';
import { coreActions } from '@sonar-software/sonar-core';
import { CloseOutlined, DeleteFilled } from '@ant-design/icons';
import React, { useCallback } from 'react';
import { useAction, useCurrentUser } from '@hooks';

export interface InitiativeScopeItemActionButtonProps {
	initiativeId: number;
	itemId: number;
	sonarObjectId: number;
	removeAction?: (id: number, sonarObjectId: number) => void;
}

export const InitiativeScopeItemActionButton: React.FC<InitiativeScopeItemActionButtonProps> = ({
	initiativeId,
	itemId,
	sonarObjectId,
	removeAction
}) => {
	const { isReadOnly } = useCurrentUser();

	const deleteScopeItemFromInitiative = useAction(coreActions.requestDeleteCoreInitiativesSonarObjects);

	const handleOnClick = useCallback(
		(event: React.MouseEvent<HTMLElement, MouseEvent>) => {
			event.stopPropagation();

			if (removeAction) {
				removeAction(itemId, sonarObjectId);
			} else {
				deleteScopeItemFromInitiative({
					initiativeId,
					sonarObjectIds: [ sonarObjectId ]
				});
			}
		},
		[ deleteScopeItemFromInitiative, initiativeId, itemId, removeAction, sonarObjectId ]
	);

	if (isReadOnly) {
		return null;
	}

	return (
		<Button
			className='delete-button'
			onClick={ handleOnClick }
			size='small'
			type='link'>
			{ removeAction ? <CloseOutlined /> : <DeleteFilled /> }
		</Button>
	);
};
